import React from 'react';
import { useOutletContext } from 'react-router-dom';
import DashboardCard from './DashboardCard';
import Spinner from '../Spinner';
import { DashboardOutletContextValue } from '../../types/dashboard';

function DashboardOverview() {
  const { modules, selectedSport, isLoading } = useOutletContext<DashboardOutletContextValue>();
  const moduleList = Object.values(modules);
  const activeModuleCount = moduleList.filter((module) => module.available).length;

  return (
    <section>
      <header className="rounded-[22px] px-4 py-4 md:px-6">
        <h1 className="text-[36px] font-semibold tracking-tight text-[#16233d]">Data Portal</h1>
        <p className="mt-2 text-[17px] text-[#6e7e98]">
          Welcome back. You have {activeModuleCount} active ingestion packages requiring attention.
        </p>
        <p className="mt-3 text-sm font-medium uppercase tracking-[0.25em] text-sky-600">
          Selected sport: {selectedSport}
        </p>
      </header>

      {isLoading && (
        <div className="mb-6 flex min-h-[120px] items-center justify-center rounded-[22px] border border-slate-200 bg-white shadow-[0_20px_44px_-34px_rgba(15,23,42,0.55)]">
          <Spinner />
        </div>
      )}

      <div className="grid gap-6 xl:grid-cols-3">
        {moduleList.map((module) => (
          <DashboardCard key={module.key} module={module} />
        ))}
      </div>
    </section>
  );
}

export default DashboardOverview;
